export default {
  title: 'Welcome to LAYA',
  subtitle: 'the inclusive learning platform',
  promoText1: 'We offer lectures for trending topics like <b>burnout</b> and <b>compliance</b> for students with learning disabilities or sensory impairments.',
  promoText2: 'For students with audio-visual impairments we provide our content in a best-fit representation.<br>Videos are accompanied by sign language.',
  promoText3: 'Our website is designed with assistive technologies in mind.',
  register: 'Register now!'
}



// WEBPACK FOOTER //
// ./src/i18n/root/en.js